import { createAction } from "@ngrx/store";
import { SYNC_SUFFIX } from "@obg/ngrx-utils";

const ACTION_PREFIX = "[Iaui Betting Limit]";

const IAUI_BETTING_LIMIT_ACTION_TYPE = Object.freeze({
	openModal: `${ACTION_PREFIX} Open Modal ${SYNC_SUFFIX}`,
	closeModal: `${ACTION_PREFIX} Close Modal ${SYNC_SUFFIX}`,
});

export namespace IauiBettingLimitAction {
	export const openModal = createAction(IAUI_BETTING_LIMIT_ACTION_TYPE.openModal);

	export const closeModal = createAction(IAUI_BETTING_LIMIT_ACTION_TYPE.closeModal);
}
